import { StyledButton } from "../../../../styles/StyledComponents";
import { white } from "../../../../styles/colors";
import * as XLSX from "sheetjs-style";
import FileSaver from "file-saver";
function Reports({  header,list,millerName }) {
  const fileExtension = ".xlsx";
  const newHead = [
    "Sr.No.",
    "Po No.",
    "Payment Condition",
    "BROKER",
    "BRAND",
    "Miller Bill No",
    "Miller Bill Date",
    "Miller Bill Weight",
    "Load Weight",
    "Bags as per miller",
    "Unloading Date",
    "Port Net Weight",
    "Unloading Bags Number",
    "Final Weight",
    "Bill Rate",
    "PO Rate",
    "Discount Expiry Date",
    "CD (%)",
    "CD Amount",
    "Final Rate",
    "Miller GST Charge",
    // "RTGS Charge",
    "Miller advance",
    "Miller Bill Amount",
    "Miller TDS",
    // "Brokerage Amount for BRIPL",
    "Brokerage Amount for Miller",
    "Other Deduction",
    "Final Amount",
    "Total Paid",
    "Balance",
  ];
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const longest = (key, array) => {
    return Math.max(
      ...array.map((it) => {
        if (it[key]) {
          return it[key] && typeof it[key] === "function"
            ? 20
            : it[key].toString().length;
        } else {
          return key.toString().length;
        }
      })
    );
  };
  const exportToCSV = (apiData, wscols, newwsrows) => {
    const fileName = `${millerName}-Account-Report)`;
    const ws = XLSX.utils.json_to_sheet(apiData, {
      skipHeader: true,
    });
    ws["!merges"] = [
      { s: { c: 0, r: 0 }, e: { c: header.length - 1, r: 1 } },
      { s: { c: 0, r: 2 }, e: { c: header.length - 1, r: 2 } },
    ];

    ws["!cols"] = wscols;
    // ws["zoom"] = { scale: 70 };
    wscols.map((data, i) => {
      ws[`A1`].s = {
        font: {
          name: "Calibri",
          sz: 14,
          bold: true,
          color: {
            rgb: "FFFFFF",
          },
        },
        fill: {
          fgColor: { rgb: "f19a30" },
        },
        border: {
          // bottom: {
          //   style: "thin",
          //   color: { rgb: "000000" },
          // },
          top: {
            style: "thin",
            color: { rgb: "000000" },
          },
          right: {
            style: "thin",
            color: { rgb: "000000" },
          },
          left: {
            style: "thin",
            color: { rgb: "000000" },
          },
        },
        alignment: {
          horizontal: "center",
          wrapText: true,
          vertical: "center",
        },
      };
      ws[`A3`].s = {
        font: {
          name: "Calibri",
          sz: 14,
          bold: true,
          color: {
            rgb: "000000",
          },
        },

        border: {
          // bottom: {
          //   style: "thin",
          //   color: { rgb: "000000" },
          // },
          top: {
            style: "thin",
            color: { rgb: "000000" },
          },
          right: {
            style: "thin",
            color: { rgb: "000000" },
          },
          left: {
            style: "thin",
            color: { rgb: "000000" },
          },
        },
        alignment: {
          horizontal: "center",
          wrapText: true,
          vertical: "center",
        },
      };
      return data;
    });
const getExcelColumnLabel = (index) => {
  let label = '';
  while (index >= 0) {
    label = String.fromCharCode((index % 26) + 65) + label;
    index = Math.floor(index / 26) - 1;
  }
  return label;
};

    apiData.slice(3, apiData.length).map((singleData, i) => {
      return newHead.map((data, i2) => {
        // 1. Get the exact cell address (e.g., "D4")
        const cellRef = `${getExcelColumnLabel(i2).toUpperCase()}${i + 4}`;
        console.log(cellRef, data,singleData, "cell ref", ws);
        
        // 2. IMPORTANT: Check if the cell exists. If not, initialize it.
        if (!ws[cellRef]) {
          ws[cellRef] = { v: "", t: "s" }; // v: value, t: type (string)
        }

      return (ws[cellRef].s = {
          font: {
            name: "Calibri",
            sz: i === 0 ? 10 : 9,
            bold:i === 0 ?true:
              singleData[header[0].name] === "Sr.No." ||
              (singleData[header[1].name] === "Sr.No." && true),
            color: {
              rgb: "000000",
            },
          },
          border: {
            bottom: {
              style: "thin",
              color: { rgb: "000000" },
            },
            top: {
              style: "thin",
              color: { rgb: "000000" },
            },
            right: {
              style: "thin",
              color: { rgb: "000000" },
            },
            left: {
              style: "thin",
              color: { rgb: "000000" },
            },
          },
          alignment: {
            horizontal:
              singleData[header[2].name] === "subHead" ? "" : "center",
            wrapText: true,
            vertical: "center",
          },
        });
      });
    });

    ws["!rows"] = newwsrows;
    const name = `All Bills`;
    const wb = {
      Sheets: { [name]: ws },
      SheetNames: [name],
    };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    
    FileSaver.saveAs(data, fileName + fileExtension);

  };
  const downloadexcel = async (list) => {
    if (list.length > 0) {
      const lists = list;

      const newArr = [];
      const newwsrows = [];
      const newObj = {};
      await newHead.map((s) => {
        newObj[s] = s;
        return s;
      });
      await newArr.push({
        "Sr.No.": `${millerName} Reports`,
      });

      await newArr.push({});
      await newArr.push({
        "Sr.No.": `Dispatch Details`,
      });
      await newArr.push(newObj);
      await lists.map((s, i) => {
        newArr.push({ "Sr.No.": lists.length - i, ...s });
        return s;
      });

      const wscols = [];
      const widthList = {};
      const array = newHead ? newHead : Object.keys(lists[0]);
      array.map((single, i) => {
        return (widthList[single] = `${Math.floor(
          1 *
            (single && single.toString().length > longest(single, lists)
              ? single.toString().length
              : longest(single, lists)
              ? longest(single, lists)
              : 1)
        )}`);
      });

      newHead.map((sH, i) => {
        wscols.push({ wch: widthList[sH] });
        return sH;
      });
      if (newArr.length === lists.length + 4) {
        exportToCSV(newArr, wscols, []);
      }
    }
  };
  return (
    <>
      {/* <StyledButton
        name={"PDF"}
        background={white}
        padding={"2px 6px"}
        fontSize={"0.8rem"}
        border={"1px solid rgb(241, 154, 48)"}
        boxShadow={"none"}
        // color={white}
        onClick={() => {
          // this.setState({
          //   downloadInvoicePdf: true,
          //   selectedDispatch: data,
          // });
        }}
      />{" "} */}
      <StyledButton
        name={".XLS"}
        background={white}
        padding={"2px 6px"}
        fontSize={"0.8rem"}
        border={"1px solid rgb(241, 154, 48)"}
        boxShadow={"none"}
         disabled={list?.length <= 0}
        onClick={() => {
          downloadexcel(list);
          // this.setState({
          //   downloadInvoicePdf: true,
          //   selectedDispatch: data,
          // });
        }}
      />
    </>
  );
}

export default Reports;
